import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex w-full items-center justify-center"
}
const _hoisted_2 = {
  key: 1,
  class: "px-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_small_loader = _resolveComponent("small-loader")!
  const _component_custom_table = _resolveComponent("custom-table")!
  const _component_modal_component = _resolveComponent("modal-component")!

  return (_openBlock(), _createBlock(_component_modal_component, {
    "is-displayed": true,
    "is-full-screen-modal": true,
    "remove-outside-click": true,
    title: _ctx.modalTitle,
    onToggleModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_small_loader)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_custom_table, {
              "allow-auto-resize": true,
              "is-action-list-not-displayed": true,
              "is-data-source-loading": _ctx.isSpotAssignHistoryListLoading,
              "table-data": _ctx.spotAssignHistory,
              "table-headers": _ctx.tableHeaders,
              onForceRefresh: _ctx.getSpotAssignHistory
            }, null, 8, ["is-data-source-loading", "table-data", "table-headers", "onForceRefresh"])
          ]))
    ]),
    _: 1
  }, 8, ["title"]))
}